import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import { TableHead, TableRow, TableCell } from 'material-ui/Table';

import { acceptedColumns, showColumnFactory } from './columns';
import { unitShape } from '../../../lib/shapes';

const styles = () => ({
  header: {
    textAlign: 'center'
  }
})

export const MaterialHead = (props) => {
  const { classes, frequencies, shiftHeadCols, columns, lengthUnit: unit } = props;
  const numberOfFrequencies = frequencies.length;
  const showColumn = showColumnFactory(columns);

  return (
    <TableHead>
      <TableRow>
        {shiftHeadCols > 0
          ? <TableCell rowSpan={2} colSpan={shiftHeadCols} />
          : null}
        {showColumn('product', <TableCell rowSpan={2}>Product</TableCell>)}
        {showColumn('construction', <TableCell rowSpan={2}>Construction</TableCell>)}
        {showColumn('resinContent', <TableCell rowSpan={2}>Resin Content (%)</TableCell>)}
        {showColumn('thickness', (
          <TableCell rowSpan={2}>
            Thickness (
            {unit.symbol}
            )
          </TableCell>
        ))}
        {showColumn('dkdf', (
          <TableCell
            colSpan={numberOfFrequencies}
            className={classes.header}
          >
            Dk/Df
          </TableCell>
        ))}
      </TableRow>
      <TableRow>
        {frequencies.map(hz => <TableCell key={hz}>{hz}</TableCell>)}
      </TableRow>
    </TableHead>
  );
}

MaterialHead.propTypes = {
  classes: PropTypes.shape({
    header: PropTypes.string
  }).isRequired,
  frequencies: PropTypes.arrayOf(PropTypes.string).isRequired,
  shiftHeadCols: PropTypes.number,
  columns: PropTypes.arrayOf(PropTypes.oneOf(acceptedColumns)),
  lengthUnit: PropTypes.shape(unitShape).isRequired,
}

MaterialHead.defaultProps = {
  shiftHeadCols: 0,
  columns: undefined 
}

export default  withStyles(styles)(MaterialHead);


// WEBPACK FOOTER //
// ./src/components/common/MaterialsTable/MaterialHead.js